// extracted by mini-css-extract-plugin
module.exports = {"arrow":"kz","dropMenu":"kA","dropMenuInner":"kB","itemborder":"kC","dropDownCurrent":"kD","menuItem":"kE","langContainer":"kF","current":"kG","outlink":"kH"};